import { SUPPORTED_LANGUAGE_CODES, DEFAULT_LANGUAGE } from "~/i18n/languages";
import { NAMESPACES, DEFAULT_NAMESPACE } from "~/i18n/namespaces";

/**
 * Shared i18next configuration for the backoffice (used by both server and client).
 *
 * The active value here is the UI **language** (en, hi, ta, …), which is a
 * SEPARATE axis from currency. Currency still drives money formatting via
 * `~/i18n/currency`; this config controls which translated strings the user sees.
 *
 * The language is APP-CONTROLLED: it is read from `User.preferredLanguage` on the
 * session server-side (see `i18next.server.ts`), NOT from the browser's
 * Accept-Language header. Missing/unsupported → English (DEFAULT_LANGUAGE).
 *
 * Catalogs live at `public/locales/<lng>/<ns>.json` and are loaded lazily, one
 * namespace at a time, by the fs backend (server) / http backend (client) wired
 * in entry.server.tsx and entry.client.tsx.
 */
export default {

  /** UI languages we allow switching to. */
  supportedLngs: SUPPORTED_LANGUAGE_CODES,

  /** English fallback — used on first login and for any missing translation. */
  fallbackLng: DEFAULT_LANGUAGE,

  /** Module-wise namespaces (one JSON file each), kept in `~/i18n/namespaces`. */
  defaultNS: DEFAULT_NAMESPACE,
  ns: NAMESPACES,

  // No <Suspense> boundary wraps the app (only root.tsx preloads a handful of
  // namespaces client-side). With the react-i18next default (useSuspense: true),
  // the first component to translate against any other namespace would suspend
  // with no fallback, discarding SSR hydration. Render synchronously instead —
  // untranslated leaf routes briefly show the key/fallback text while their
  // namespace loads, rather than throwing.
  react: {
    useSuspense: false,
  },
};
